module.exports = __webpack_public_path__ + "img/video-conferencia-com-multitela.03999b3d.png";